import React, { useState } from "react";
import Header from "../header/Header";
import BreadCrumb from "../global/breadcrumbs/BreadCrumb";
import { apirequest } from "../../API/api";
import { endpoint } from "../../API/config";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import WhiteSpace from "../global/regEx/WhiteSpaceValidator";

const AddProductGroup = () => {
  const login_Details = useSelector(state=>state?.loginData?.LoginDetails);
  const [productGroupName, setProductGroupName] = useState("");
  let history = useHistory();
  const fetchAddProductGroup = () => {
    return apirequest({
      url: `${endpoint.add_productGroup.addr}`,
      method: "post",
      data: {
        productGroupName: productGroupName,
        isActive: "1",
        createdBy: login_Details.userImsPin,
      },
    });
  };

  //API request to add new product group data
  const { refetch: addProductGroupRefetch } = useQuery(
    endpoint.add_productGroup.key,
    fetchAddProductGroup,
    {
      enabled: false,
      onSuccess :(res)=>{alert(res.data.message),window.location.reload(false);},
      retry: 0,
      onError:(err)=>{
        alert(err.data.message);
      }
    },
  );

  const onsave = e => {
    if(WhiteSpace(productGroupName)){
      alert("Please enter product group name");
    }else{
      addProductGroupRefetch();
    }
    e.preventDefault();
  };

  return (
    <div className="flex flex-col ">
      <Header />
      <BreadCrumb />
      <div className="mt-2 mx-12  px-8 py-2  ">
        <form
          className=" flex flex-col relative bg-secondary-100 py-6 shadow-outer"
          onSubmit={onsave}>
          <div className="h-full space-y-6  px-12 py-6 relative">
            <div className="flex  justify-between py-5">
              <label className=" font-normal text-lg font-ibm ">
                Product Group
                <input
                  required
                  type="text"
                  name="productGroupName"
                  className="border-2 h-10 border-secondary-300 absolute left-48 w-3/6 rounded-lg focus:outline-none"
                  value={productGroupName}
                  onChange={e => setProductGroupName(e.target.value)}
                />
              </label>
            </div>
          </div>
          <div className="flex items-center justify-center mt-7 pr-20">
            <button className="bg-primary-200 text-white font-ibm px-12 rounded-xl hover:opacity-75 shadow-outer py-[10px] text-base font-medium mr-10 cursor-pointer">
              SAVE
            </button>
            <p onClick={history.goBack} className=" text-black boxShadow-forButton font-ibm px-10 rounded-xl hover:opacity-75 shadow-outer text-base font-medium py-[10px] cursor-pointer">
              EXIT
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProductGroup;
